import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GamificationRequestComponent } from './gamification-request/gamification-request.component';
import { AuthGuardService } from '../auth-guard.service';
import { GamificationInquiryComponent } from './gamification-inquiry/gamification-inquiry.component';
import { GamificationResultComponent } from './gamification-result/gamification-result.component';

const routes: Routes = [
  {
    path: 'contest-request',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'contest-request/:id',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'contest-result/:definition',
    component: GamificationResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'incentive-request',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'incentive-request/:id',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'incentive-inquiry',
    component: GamificationInquiryComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'incentive-result/:id',
    component: GamificationResultComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'commission-request',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'commission-request/:id',
    component: GamificationRequestComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class GamificationRoutingModule {}
